import { createContext, useContext, useState, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { RiskAnalysisModal } from "@/components/risk/RiskAnalysisModal";
import { useSessionSwitcher } from "@/contexts/SessionSwitcherContext";

type RiskAnalysisModalContextType = {
  showRiskAnalysisModal: () => void;
};

const RiskAnalysisModalContext =
  createContext<RiskAnalysisModalContextType | null>(null);

export function useRiskAnalysisModal() {
  const context = useContext(RiskAnalysisModalContext);
  if (!context) {
    throw new Error(
      "useRiskAnalysisModal must be used within RiskAnalysisModalProvider"
    );
  }
  return context;
}

export function RiskAnalysisModalProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { currentSessionId } = useSessionSwitcher();

  const showRiskAnalysisModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <RiskAnalysisModalContext.Provider value={{ showRiskAnalysisModal }}>
      {children}
      <RiskAnalysisModal
        isOpen={isOpen}
        onClose={closeModal}
        onChooseWizard={() => {
          closeModal();
          if (currentSessionId) {
            navigate(`/analiza-risc/${currentSessionId}`);
          }
        }}
        onChooseUpload={() => {
          closeModal();
          navigate("/onboarding/analiza-risc");
        }}
      />
    </RiskAnalysisModalContext.Provider>
  );
}
